import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountDisplayTypes, AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from "./module-config/module-config";

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css']
})

export class AccountComponent implements OnInit {

    public displayAreaConfig!:AccountDisplayTypes;
    
    constructor(
        public router: Router,
        @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
    ){
        this.displayAreaConfig = accountRouterConfig.displayAreaConfig;
    }
    
    ngOnInit(): void{}

}